/*
Schema for server's responses
{
  originalEvent: { isTrusted: true },
  xhr: {},
  request: {
    async: true,
    crossDomain: false,
    withCredentials: false,
    headers: {},
    method: 'POST',
    responseType: 'json',
    timeout: 0,
    url: '/api/',
    body: '{}',
  },
  status: 200,
  responseType: 'json',
  response: {
    data: [],
    error: null,
    pagination: {},
  },
}
*/

import { NOTIFICATIONS_STATUS } from 'notifications'
import System from 'system'

import serverResponse from '../serverResponse'

const epicResponseHandler =
  (actionFunction, originalAction = {}) =>
  (requestResponse) => {
    const defaultResponse = {
      code: 570,
      response: {
        error: { msg: 'Sin respuesta del servidor.' },
      },
    }
    const response = {
      ...defaultResponse,
      ...(requestResponse || {}),
    }

    const responsePayload = serverResponse(response.response, {
      loaded: true,
      originalAction,
    })

    const currentAction = actionFunction(responsePayload, originalAction) || {}

    const notification = currentAction.notification || originalAction.notification || {}

    if (notification.id) {
      setTimeout(() => {
        System.addNotification({
          ...notification,
          dismissAfter: 3000,
          status: NOTIFICATIONS_STATUS.SUCCESS,
        })
      }, 0)
    }

    return currentAction
  }

export default epicResponseHandler
